/* eslint-disable jsx-a11y/role-supports-aria-props */
import * as React from 'react';
import { useIntl } from 'react-intl';
import { IHeadProps } from '../TableHead';

interface IComponentProps {
  label: boolean;
  action?: (title: string, e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  stateStartMin: number | string;
  stateStartMax: number | string;
  stateMin: number | string;
  stateMax: number | string;
  setStateValue: (
    event: React.ChangeEvent<HTMLInputElement>,
    key: string,
    val: string | number | null,
    name: string
  ) => void;
  menuNameOpen: {
    [key: string]: boolean;
  };
}

type Props = IHeadProps & IComponentProps;

const SimpleInput: React.FC<Props> = ({ ...props }) => {
  const { formatMessage: f } = useIntl();

  const setStateValue = (e: any) => {
    const { columns, filterComponent } = props;
    props.setStateValue(e, columns?.name || '', null, filterComponent?.type || '');
  };

  const actionOpen = (e: any) => {
    props.actionOpen(e, props.columns?.name || '');
  };

  const actionSave = (e: any) => {
    const { columns, parentState, filterComponent } = props;
    const onKeyPress = e.currentTarget.getAttribute('data-on-key-press');
    if (
      !onKeyPress ||
      (onKeyPress &&
        e.key === 'Enter' &&
        parentState[filterComponent?.type || ''][columns?.name || ''])
    ) {
      props.actionSave(
        columns?.name || '',
        parentState[filterComponent?.type || ''][columns?.name || ''],
        e,
        filterComponent?.type || '',
        columns?.title || ''
      );
    }
  };

  const action = (e: any) => {
    if (props.action) {
      props.action(props.columns?.name || '', e);
    }
  };

  const reset = () => {
    if (props.columns) {
      props.reset(props.columns, 'simpleInput', true);
    }
  };

  const { columns, filterComponent, parentState } = props;
  return (
    <div
      data-cy={`simple-input-popup-${columns?.name}`}
      className={`label ${props.label ? 'label-primary mb-xs position-relative label--filter' : ''}
          ${props.menuNameOpen[props.columns?.name || ''] === props.label ? 'open' : ''}`}
      style={{ padding: !props.label ? '0px' : '9px 8px 8px 8px' }}
    >
      {props.label && (
        <span onClick={actionOpen}>
          <a
            href="#"
            title={f({ id: 'table.filter.button' })}
            data-cy={`simple-input-fitler-button-${columns?.name}`}
            className="dropdown-toggle text-white text-decoration-none"
            id="dropdownMenu13"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="true"
          >
            {columns?.title}: {filterComponent?.selectedValue}
          </a>
          <a
            href="#"
            title={f({ id: 'table.filter.remove' })}
            className="text-white"
            onClick={action}
            style={{ padding: '8px', margin: '-8px -8px -8px 0' }}
          >
            <i className="cmd-icon cmd-icon-remove-sm" />
          </a>
        </span>
      )}

      <div
        className="dropdown-menu dropdown-menu-custom fs-2 js-dropdown-keep-open"
        aria-labelledby="dropdownMenu10"
      >
        <div className="pt-1 pb-2 px-2 border-bottom-on open">
          <div
            className=" form-control-labels"
            style={{ background: '#fff', border: 'none', color: '#555', padding: '0px' }}
          >
            <input
              type="text"
              className="form-control font-weight-normal fs-2 filterMenu"
              data-cy="simple-input-filter-input"
              placeholder={
                filterComponent?.selectedValue !== null ? '' : filterComponent.placeholder
              }
              autoFocus={true}
              defaultValue={filterComponent?.selectedValue}
              value={
                parentState[filterComponent?.type || ''][columns?.name || ''] === null
                  ? filterComponent?.selectedValue
                  : parentState[filterComponent?.type || ''][columns?.name || '']
              }
              onChange={setStateValue}
              onKeyPress={actionSave}
              data-on-key-press={true}
            />
          </div>
        </div>
        <div className="row m-0 px-1 py-1 pt-2">
          <div className="col-6 px-xs">
            <a
              href="#"
              title={f({ id: 'table.filter.reset' })}
              data-cy="simple-input-filter-button-reset"
              id="reset"
              className={`e-button d-flex
                  ${
                    parentState[filterComponent?.type || ''][columns?.name || ''] &&
                    parentState[filterComponent?.type || ''][columns?.name || ''].length !== 0
                      ? ''
                      : 'disabled'
                  }`}
              onClick={reset}
            >
              Reset
            </a>
          </div>
          <div className="col-6 px-xs">
            <a
              href="#"
              title={f({ id: 'table.apply' })}
              data-cy="simple-input-filter-button-aplly"
              className={`e-button e-button--gray d-flex
                  ${
                    parentState[filterComponent?.type || ''][columns?.name || ''] &&
                    parentState[filterComponent?.type || ''][columns?.name || ''].length !== 0
                      ? ''
                      : 'disabled'
                  }`}
              onClick={actionSave}
            >
              {f({ id: 'table.apply' })}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SimpleInput;
